export const messages = {
  en: {
    login: {
      title: 'User Purchase Login',
      register: 'Register Account',
      usernamePlaceholder: 'Username/Phone Number',
      passwordPlaceholder: 'Password',
      codePlaceholder: 'Verification Code',
      codeAlt: 'Can\'t see clearly? Click to change another verification code',
      loginBtn: 'Login',
      usernameRequired: 'Username cannot be empty',
      passwordRequired: 'Password cannot be empty',
      codeRequired: 'Verification code cannot be empty',
      notPurchaser: 'Non-purchasing users please log in from the supplier/agent entrance'
    }
  },
  zh: {
    login: {
      title: '用户采购登录',
      register: '注册账号',
      usernamePlaceholder: '用户名/手机号码',
      passwordPlaceholder: '密码',
      codePlaceholder: '验证码',
      codeAlt: '看不清？点击更换另一个验证码',
      loginBtn: '登录',
      usernameRequired: '用户名不能为空',
      passwordRequired: '密码不能为空',
      codeRequired: '验证码不能为空',
      notPurchaser: '非采购用户请从供应商、代理商入口登录'
    }
  }
}